import React, { useMemo } from 'react';
import type { RenderColumnDataProps } from 'c-pagination';
import type { Displays_LineItem } from 'c-sdk';
import { Chip } from 'c-components';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { lineItemResolutionSummary } from './lineItemLogic';

type Props = RenderColumnDataProps<Displays_LineItem>;

/**
 * We're assuming this component will be used in on a page which includes the `resolutions` relationship on line items.
 */
const LineItemResolutionsCell: React.FC<Props> = ({ entity }) => {
    const summary = useMemo(() => lineItemResolutionSummary(entity), [entity]);
    const extraResolutions = summary.extra;

    if (summary.main != null) {
        return (
            <Stack gap={0.5} flexDirection="row" alignItems="center">
                {summary.main}
                <Tooltip
                    title={
                        <>
                            {extraResolutions.map(res => (
                                <Typography key={res} variant="body2">
                                    {res}
                                </Typography>
                            ))}
                        </>
                    }
                >
                    <Box>
                        <Chip label={`+${extraResolutions.length}`} size="small" color="primary" />
                    </Box>
                </Tooltip>
            </Stack>
        );
    }

    return <>{summary.text}</>;
};

export default LineItemResolutionsCell;
